// Copyright (c) 2025 Annadaneshwar Yadawad. All rights reserved.

// Branding and configuration
const branding = {
  appName: 'Servantica',
  company: 'Annadaneshwar Yadawad',
  tagline: 'Empowering your business with unified, AI-powered solutions',
  
  // Assistant Configuration
  assistants: {
    // Global settings
    enabled: true,
    position: 'bottom-right', // 'bottom-right', 'bottom-left', 'top-right', 'top-left'
    
    // Animation settings
    animations: {
      enabled: true,
      intensity: 'medium', // 'subtle', 'medium', 'energetic'
      entranceDelay: 0.2, // seconds between icon appearances
      hoverEffect: 'lift', // 'lift', 'scale', 'glow'
      pulseSpeed: 1.5, // seconds for pulse animation
    },
    
    // Voice Assistant
    voice: {
      enabled: true,
      language: 'en-US',
      continuous: false,
      interimResults: false,
      showTooltip: true,
      autoHide: 5000, // ms to auto-hide after activation
      
      // Voice synthesis settings
      synthesis: {
        voiceGender: 'male', // 'female', 'male', 'auto'
        rate: 0.9, // Speech rate (0.1 to 10)
        pitch: 1.1, // Voice pitch (0 to 2) - higher for more feminine
        volume: 1.0
      },
      
      commands: {
        'dashboard': '/dashboard',
        'login': '/login', 
        'home': '/',
        'features': '/features',
        'pricing': '/pricing',
        'contact': '/contact',
        'about': '/about',
        'testimonials': '/testimonials',
        'chat': 'open-chat',
        'help': 'show-help'
      },
      feedback: {
        success: 'Command executed successfully!',
        error: 'Sorry, I did not understand that command. Try saying help, dashboard, chat, or ask who is the owner',
        listening: 'Listening... Say a command'
      }
    },
    
    // Chat Assistant
    chat: {
      enabled: true,
      autoOpen: false,
      showNotification: true,
      welcomeMessage: 'Hi! How can I help you with Servantica today?',
      placeholder: 'Type your message...',
      showOnPages: ['landing', 'dashboard', 'all'], // or 'all' for all pages
      position: 'overlay', // 'overlay', 'sidebar', 'inline'
      size: 'medium' // 'small', 'medium', 'large'
    }
  },

  // Theme colors
  colors: {
    primary: '#2563eb',
    primaryHover: '#1d4ed8',
    secondary: '#4f46e5',
    secondaryHover: '#3730a3',
    accent: '#10b981',
    voice: {
      default: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)',
      active: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
      hover: 'linear-gradient(135deg, #3730a3 0%, #4338ca 100%)'
    },
    chat: {
      default: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
      active: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      hover: 'linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%)'
    }
  }
};

export default branding;